import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconShow: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-1.2 0a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.4c-4.313 0-7.735 2.592-9.515 5.41a2.226 2.226 0 0 0 0 2.38C4.265 16.009 7.687 18.6 12 18.6c4.17 0 7.706-2.591 9.51-5.408a2.217 2.217 0 0 0 .005-2.383C19.735 7.992 16.313 5.4 12 5.4Zm-8.5 6.05C5.11 8.9 8.185 6.6 12 6.6s6.89 2.3 8.501 4.85c.213.337.212.762-.001 1.095-1.634 2.551-4.824 4.855-8.5 4.855-3.814 0-6.889-2.3-8.5-4.85a1.026 1.026 0 0 1 0-1.1Z"
    />
  </Icon>
);
